import { cn } from '@/lib/utils';
import { ChevronDown } from 'lucide-react';
import { forwardRef, useRef } from 'react';
import H4 from '../ui/H4';

export interface IAccordion {
    title: string;
    text: string;
    index?: number;
    isOpen?: boolean;
    // eslint-disable-next-line no-unused-vars
    toggleAccordion?: (index: number) => void;
    className?: string;
}

const Accordion = forwardRef<HTMLDivElement, IAccordion>(function Accordion(
    { title, text, index = 0, isOpen, toggleAccordion = () => {}, className },
    ref,
) {
    const contentRef = useRef<HTMLDivElement>(null);

    return (
        <button
            type="button"
            onClick={() => toggleAccordion(index)}
            className={cn('border-b border-black/50 w-full flex flex-col pb-2', className)}
        >
            <div className="flex justify-between items-center w-full text-left focus:outline-none gap-7">
                <div className="flex justify-between items-center w-full">
                    <H4 className="max-lg:text-[28px] w-5/6 font-bold lg:text-h5 2xl:text-h4">{title}</H4>
                    <ChevronDown
                        className={cn(
                            'ml-8 mr-4 scale-125 transition-transform duration-300 text-primary min-w-6 min-h-6',
                            isOpen && 'rotate-180',
                        )}
                        height={48}
                    />
                </div>
            </div>
            <div
                ref={ref}
                className="flex items-center w-full overflow-hidden transition-all duration-300 ease-in-out text-left gap-7 leading-tight"
                style={{
                    maxHeight: isOpen ? `${contentRef.current?.scrollHeight}px` : '0px',
                    opacity: isOpen ? 1 : 0,
                }}
            >
                <p
                    className="font-helveticaNeue max-lg:text-sm text-p py-3 whitespace-pre-line lg:w-5/6 indent-16"
                    ref={contentRef}
                >
                    {text}
                </p>
            </div>
        </button>
    );
});

export default Accordion;
